import { createFileRoute } from "@tanstack/react-router";
import DocumentBlogArticle from "@/components/site/DocumentBlogArticle";
import { blogDrafts } from "@/lib/blog-drafts";
import { documentBlogHead } from "@/lib/document-blog-head";

export const Route = createFileRoute("/iop-php-cost-nj")({
  head: () => documentBlogHead(blogDrafts.cost),
  component: CostBlog,
});

function CostBlog() { return <DocumentBlogArticle draft={blogDrafts.cost} />; }